import i18n from 'localization';
import { router } from 'routers';
import { theme } from 'config/material';
import { CssBaseline } from '@mui/material';
import { StrictMode, Suspense } from 'react';
import { Spinner } from 'components/spinner';
import { createRoot } from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import reportWebVitals from './reportWebVitals';
import { queryClient } from 'config/react-query';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import './index.css';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <Suspense fallback={<Spinner />}>
      <I18nextProvider i18n={i18n}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
              <RouterProvider router={router} />
              <CssBaseline />
              <ToastContainer />
            </ThemeProvider>
          </QueryClientProvider>
        </LocalizationProvider>
      </I18nextProvider>
    </Suspense>
  </StrictMode>
);

reportWebVitals();
